// extracted by mini-css-extract-plugin
export default {"errorDisplay":"sg","swrErrorOverlay":"tg","crashReport":"ug"};